<template>
  <div name="normalButton">
    <v-btn
      @click="onClick()"
      :color="borderColor"
      elevation="0"
      light
      large
      outlined
      :disabled="disabled"
      :style="{
        backgroundColor: backgroundColor + ' !important',
      }"
      :height="height"
    >
      <v-icon left :color="textColor" v-if="icon"> {{ icon }} </v-icon>
      <div class="normal-button-text">
        <slot></slot>
      </div>
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "normalButton",
  props: {
    text: String,
    icon: String,
    height: Number,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      backgroundColor: this.$vuetify.theme.themes.light.backgroundNormalButton,
      textColor: this.$vuetify.theme.themes.light.bodyText,
      borderColor: this.$vuetify.theme.themes.light.borderColor,
    };
  },

  methods: {
    onClick() {
      this.$emit("on-click");
    },
  },
};
</script>
<style>
.normal-button-text {
  color: #4d5656 !important;
  font-weight: normal !important;
}
</style>
